export const HeroData = {
  title: 'Cadastre-se e feche muitos serviços direto do seu celular',
  subtitle:
    'São mais de <strong>+450 mil</strong> pedidos solicitados por mês.',
  fistButtonText: 'Começar cadastro',
  secondButtonText: 'Ou encontre um profissional',
  secondButtonLink: 'https://www.getninjas.com.br/',
};

export const ProspectHeroData = {
  title: 'Tem clientes te esperando!',
  subtitle: 'Cadastre-se como profissional e comece a receber pedidos.',
  preDescription: 'São',
  strongDescription: '+200 mil',
  description: 'pedidos solicitados por mês.',
  fistButtonText: 'Quero me cadastrar',
  secondButtonText: 'Ou encontre um profissional',
  secondButtonLink: 'https://www.getninjas.com.br/',
};

export const BenefitsData = {
  title: 'Benefícios para você',
  iconAlt: 'Icone de economia',
  descriptionImageOne:
    'Os pedidos de serviço chegam a toda hora no seu celular.',
  descriptionImageTwo:
    'Você não paga para ver os pedidos e investe somente no que gostar.',
  descriptionImageThree:
    '100% do valor do serviço fica com você. Aqui não tem mensalidade!',
};

export const HowWorksData = {
  title: 'Como funciona?',
  descriptionFirstPart: 'A maior plataforma de serviços do Brasil: são mais de',
  descriptionSecondPart: '5 milhões de pedidos por ano',
  descriptionthirdPart:
    'e mais de 500 tipos de serviços disponíveis para você se cadastrar.',
  buttonText: 'Cadastre-se gratuitamente',
  buttonLink: 'https://www.getninjas.com.br/',
  videoLink: 'https://www.youtube.com/embed/YJFpU3tNbGw',
};

export const ProspectHowWorksData = {
  buttonText: 'Quero ser um ninja',
};

export const HowMuchData = {
  title: 'Quanto custa?',
  descriptionFirstPart:
    'O GetNinjas não cobra mensalidade e você não paga nada para se cadastrar. Você só investe nos serviços que tiver interesse e fica com',
  descriptionSecondPart: '100% do valor negociado!',
};

export const WhyUsData = {
  title: 'Por que o GetNinjas?',
  descriptionFirstPart:
    'Todos os clientes que pedem por serviço na sua região aparecem no seu aplicativo. São diversos profissionais que transformaram sua carreira em uma',
  descriptionSecondPart: 'história de sucesso.',
};

export const DepoimentsData = {
  title: 'O que os profissionais dizem',
  maxStarts: 5,
  reviews: [
    {
      id: 1,
      name: 'Alexandre de Lucca',
      profission: 'Mecânico de Autos',
      text: 'O GetNinjas trouxe inovação para o mercado e para o meu negócio.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Marcela Mahayana',
      profission: 'Aulas de Canto',
      text: 'O GetNinjas representa acessibilidade para mim.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Levi da Hora',
      profission: 'Marido de Aluguel',
      text: 'Me aposentei, mas com o GetNinjas voltei à ativa.',
      rating: 5,
    },
  ],
};

export const ProspectDepoimentsData = {
  reviews: [
    {
      id: 1,
      name: 'Alexandre de Lucca',
      profission: 'Mecânico de Autos',
      text: 'O GetNinjas trouxe inovação para o mercado e para o meu negócio.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Marcela Mahayana',
      profission: 'Aulas de Canto',
      text: 'O GetNinjas representa acessibilidade para mim.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Levi da Hora',
      profission: 'Marido de Aluguel',
      text: 'Me aposentei, mas com o GetNinjas voltei à ativa.',
      rating: 5,
    },
    {
      id: 4,
      name: 'Henrique e Samara',
      profission: 'Adestradores',
      text: 'O GetNinjas foi importante pois possibilitou a criação da nossa marca.',
      rating: 5,
    },
    {
      id: 5,
      name: 'Keila',
      profission: 'Personal Chef',
      text: 'Consegui realizar meu sonho de virar empresária através do GetNinjas.',
      rating: 5,
    },
    {
      id: 6,
      name: 'Ricardo',
      profission: 'Pintor',
      text: 'O GetNinjas me ajuda a gerir o meu negócio e aumentar minha equipe!',
      rating: 5,
    },
  ],
};
